import {Controller} from '@hotwired/stimulus';
import Axios from "../axios";

export default class extends Controller {

    static get targets() {
        return ['form', 'results', 'pagination'];
    }

    connect() {
        this.filters = {};
        this.currentLanguageCode = document.documentElement.lang.split('-')[0];
        this.filter();
    }

    formTargetConnected() {
        const form = this.targets.find('form');
        form.addEventListener('submit', (e) => {
            e.preventDefault();

            if (this.element.classList.contains('loading')) {
                return;
            }

            delete this.filters['page'];
            this.search();
        });
    }

    async search() {
        this.element.classList.add('loading');
        const form = this.targets.find('form');
        const data = new URLSearchParams(new FormData(form)).toString();
        const filters = new URLSearchParams(this.filters).toString();
        let url =`${form.action}?rest_language=${this.currentLanguageCode}&${data}`;
        if (filters) {
            url += `&${filters}`;
        }

        let response = null;
        try {
            response = await Axios.get(url);
            response = response.data.data;
            this.clearResults();
            response.data.forEach((result) => {
                this.insertResult(result);
            })

            this.targets.find('pagination').innerHTML = response.pagination;
            this.pagination();
            this.element.classList.remove('loading');
        } catch (error) {
            response = error.response.data.data;
            this.element.classList.remove('loading');
        }
    }

    filter() {
        this.element.querySelectorAll('.filters').forEach((filters) => {
            const name = filters.getAttribute('data-filter');
            const allFilters = filters.querySelectorAll('.single-filter');
            allFilters.forEach((filter) => {
                filter.addEventListener('click', (e) => {
                    e.preventDefault();

                    allFilters.forEach((filter) => filter.classList.remove('active'));

                    this.filters[name] = filter.getAttribute(`data-${name}`);
                    filter.classList.add('active');

                    this.search();
                });
            });

            const allSorts = filters.querySelectorAll('.single-sort');
            allSorts.forEach((sort) => {
                sort.addEventListener('click', (e) => {
                    e.preventDefault();

                    const isAlreadyActive = sort.classList.contains('active');
                    allSorts.forEach((filter) => filter.classList.remove('active'));

                    if ( !isAlreadyActive ) {
                        this.filters['sort_by'] = sort.getAttribute(`data-sort`);
                        sort.classList.add('active');
                    } else {
                        delete this.filters['sort_by'];
                    }

                    this.search();
                });
            });
        });
    }

    pagination() {
        const pagination = this.targets.find('pagination');
        pagination.querySelectorAll('a').forEach((a) => {
            a.addEventListener('click', (e) => {
                e.preventDefault();
                const urlParams = new URLSearchParams(new URL(a.getAttribute('href')).search);
                this.filters['page'] = urlParams.get('page') ? urlParams.get('page') : 1;
                this.search();
            });
        });
    }

    clearResults() {
        this.targets.find('results').innerHTML = '';
    }

    insertResult(data) {

        let link = '';
        if (data['url']) {
            link = `<a href="${data['url']}">${data['url']}</a>`;
        }
        this.targets.find('results').insertAdjacentHTML('beforeend', `<p>${data['title']}${link}</p>`);
    }
}
